// "Visto recientemente": mismo criterio de privacidad que ya usa el carrito
// (CartContext.js) -- localStorage puro, sin cookie, sin servidor, sin
// enlazar a ninguna cuenta ni sesion. Es solo el propio navegador
// recordando que paginas de producto visito, para comodidad de esa misma
// persona -- no requiere el consentimiento de "marketing"/"analytics" del
// banner de cookies (CookieConsent.js) porque no es rastreo con fines
// publicitarios ni de medicion, es la misma naturaleza que recordar el
// contenido del carrito.
//
// Deliberadamente NO es lo mismo que "que busca la gente" (una idea
// distinta, de marketing/tendencias, comentada con el usuario y aparcada
// pendiente de decision explicita) -- esto es mas simple y de menor huella:
// solo recuerda lo que ESA persona ya vio, en ESE navegador.
const STORAGE_KEY = 'esganga_recently_viewed';
const MAX_ITEMS = 12;

function readAll() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
        // localStorage puede fallar (navegacion privada, cuota llena,
        // navegador que lo bloquea) -- nunca debe romper la pagina por esto,
        // simplemente se comporta como si no hubiera historial.
        return [];
    }
}

// Se llama al entrar en la ficha de un producto. Mueve el producto al
// principio si ya estaba (visto de nuevo = mas reciente, no un duplicado),
// y recorta a MAX_ITEMS para no crecer sin limite.
export function recordRecentlyViewed(deal) {
    if (!deal || !deal.id) {
        return;
    }
    try {
        const withoutThisDeal = readAll().filter((item) => String(item.id) !== String(deal.id));
        const entry = {
            id: deal.id,
            name: deal.name || '',
            image: deal.image || '',
            price: Number(deal.price) || 0,
            oldPrice: Number(deal.oldPrice) || 0,
            store: deal.store || '',
            category: deal.category || ''
        };
        const updated = [entry, ...withoutThisDeal].slice(0, MAX_ITEMS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch (error) {
        // Ver comentario de readAll() -- fallar en silencio.
    }
}

// `excludeId` para no mostrar la propia ficha que se esta viendo ahora
// mismo dentro de su propia lista de "visto recientemente".
export function getRecentlyViewed(excludeId) {
    const excludeKey = excludeId != null ? String(excludeId) : null;
    return readAll().filter((item) => !excludeKey || String(item.id) !== excludeKey);
}

// Control real sobre datos propios: el usuario puede borrar su propio
// historial cuando quiera (boton "Borrar historial" en RecentlyViewed.js).
export function clearRecentlyViewed() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        // Ver comentario de readAll() -- fallar en silencio.
    }
}
